import { Route, Routes, useNavigate, useLocation } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Home from "./page/home";
import Navbar from "./components/shared/navbar";
import Footer from "./components/shared/footer";
import ScriptWriting from "./components/home/scriptWriting";
import ScriptModals from "./page/ScriptModals/scriptModals";
import { useState, useEffect } from "react";
import Demo from "./components/demo";
import Register from "./components/account/Register";
import Login from "./components/account/Login";
import DocumentBase from "./components/home/knowledgebaseDocument";
import ManuallyAddDoc from "./components/home/ManuallyAddDoc";
import { useLayoutEffect } from "react";
// import dotenv from "dotenv";
// import { useNavigate } from "react-router-dom";

function App() {
  // dotenv.config();
  const navigate = useNavigate();
  const location = useLocation();
  const [modals, setModals] = useState({
    modelAction: false,
    modalMagic: false,
    modalInstruction: false,
    modalPost: false,
    modalStats: false,
  });

  const isAuthenticated = localStorage.getItem("bearerToken");

  return (
    <div className="App">
      <ToastContainer />

     {isAuthenticated && <Navbar/>}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route
          path="/script"
          element={<ScriptWriting setModals={setModals} modals={modals} />}
        />
        <Route path="/demo" element={<Demo />} />
        <Route path="/Document_Preview" element={<DocumentBase />} />
        <Route path="/Manually_Added_Doc" element={<ManuallyAddDoc />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
